<!--
 * @Author: your name
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-07-29 22:57:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\aftermarket/returnGoodsForm.vue
-->
<template>
  <div class="n_continer">
    <div style="height:20px"></div>
    <div class="order_goods" v-for="item in child_order_list" :key="item.id">
      <img :src="item.goods_image" alt />
      <div>
        <p>{{item.goods_name}}</p>
        <b>{{item.sku_name}}</b>
        <span>
          <i>￥</i>
          {{item.goods_price_dollar}}
        </span>
      </div>
    </div>
    <div class="n_content">
      <ul>
        <li>
          <div class="n_num">申请数量</div>
          <div class="flex">
            <div class="n_jian" @click="subtractFg">
              <p></p>
            </div>
            <input class="n_input" type="number" @blur="blurFg" v-model="num" :disabled="isEdit" />
            <p class="n_add" @click="addFg">+</p>
          </div>
        </li>
        <li @click="applicationFg">
          <p>申请原因</p>
          <div class="flex align_center">
            <p>{{from.curRefund}}</p>
            <span class="iconfont iconarrow-right-bold"></span>
          </div>
        </li>
      </ul>
    </div>
    <div class="n_content">
      <ul>
        <!-- <li>
          <p>退款总额</p>
          <p>¥ {{from.refundNum}}</p>
        </li>-->
        <li>
          <p>商品金额</p>
          <p v-if="child_order_list[0]">¥ {{goods_price_dollar}}</p>
        </li>
        <li>
          <p>运费金额</p>
          <p v-if="child_order_list[0]">¥ {{ship_amount_dollar}}</p>
        </li>
      </ul>
    </div>
    <div class="n_content">
      <div class="n_padding">
        <h2>{{ goodsInfo.refundId == 3 ? '换货' : '退货'}}说明</h2>
        <div class="n_teraea">
          <van-field
            v-model="from.caused"
            rows="2"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="请详细描述您的问题，并根据您的描述上传商品照片及视频，照片需包括：外包装、内包装照片以及商品图片"
            show-word-limit
          />
        </div>
        <div class="n_uploadimg">
          <div class="flex align_center">
            <h2>图片说明</h2>
            <p class="n_oimg">上传的图片请务必体现商品细节（最多6张）</p>
          </div>
          <van-uploader class="n_imgList" v-model="fileList" multiple :max-count="6" />
        </div>
        <div class="n_uploadimg">
          <div class="flex align_center">
            <h2>上传视频</h2>
            <p class="n_oimg">上传的视频请务必体现商品细节</p>
          </div>
          <van-uploader
            accept="video/*"
            class="n_imgList"
            v-model="videos"
            :after-read="afterRead"
            :max-count="1"
            upload-icon="play-circle-o"
          />
        </div>
      </div>
    </div>
    <div class="n_content">
      <ul>
        <li>
          <!-- <p>联系人</p>
          <p>¥ 10.00</p>-->
          <van-field v-model="from.send_back_name" label="联系人" placeholder="请输入联系人" />
        </li>
        <li>
          <van-field v-model="from.send_back_phone" type="tel" label="联系电话" placeholder="请输入联系电话" />
          <!-- <p>联系电话</p>
          <p>¥ 10.00</p>-->
        </li>
      </ul>
    </div>
    <div class="n_btn" @click="sublimeFg">提交</div>
    <div class="n_height"></div>
    <!-- 选择售后原因 -->
    <van-action-sheet v-model="isShow" title="申请原因" cancel-text="取消" safe-area-inset-bottom>
      <div
        class="nm_content"
        v-for="item in actions"
        :key="item.id"
        @click="selectFg(item)"
      >{{item.name}}</div>
    </van-action-sheet>
    <van-overlay :show="isLoading" @click="isLoading = false">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" text-color="#0094ff" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { add, subtract, multiply, divide } from '../../public/floatPublic.js'
export default {
  name: 'aftermarketList',
  data() {
    return {
      form: {},
      fileList: [],
      goodsInfo: {},
      child_order_list: [],
      imgList: [],
      videoList: [],
      num: 1,
      actions: [],
      isShow: false,
      from: { curRefund: '请选择', refundNum: 0, image: '' },
      isEdit: false,
      images: [],
      videos: [],
      videomos: '',
      isLoading: false,
      goods_price_dollar: '',
      ship_amount_dollar: '',
    }
  },
  created() {
    this.goodsInfo = this.$route.query
    this.getRefundList()
    if (!this.$route.query.type) {
      this.getRefundType()
    }
    if (this.$route.query.type) {
      console.log(this.$route.query)
      this.refundInfo = this.$route.query
      this.getDetail()
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    async getRefundType() {
      console.log(this.goodsInfo)
      let res = await this.http('ClientOrder.getRefundType', {
        order_detail_id: this.goodsInfo.orderId,
      })
      this.refundInfo = res.content
      // this.num = res.content.max_edit_num
      this.isEdit = res.content.is_edit_num == 0 ? true : false
      this.getOrderDetail()
    },
    //获取售后详情
    async getDetail() {
      let res = await this.http('ClientOrder.refundApplyDetail', {
        order_detail_id: this.$route.query.orderDetailId,
        apply_sn: this.$route.query.sn,
      })
      console.log(res.content)
      this.from = res.content
      this.from.curRefund = res.content.apply_case_cn
      this.from.apply_case = res.content.apply_case
      console.log(this.from)
      // this.images = res.content.image.split(',')
      // this.fileList = res.content.image.split(',')
      res.content.image.split(',').map((item) => {
        this.fileList.push({ url: item })
      })
      this.videos.push({ url: res.content.video })
      this.videomos = res.content.video
      this.getOrderDetail()
      console.log(res)
    },
    selectFg(item) {
      this.from.curRefund = item.name
      this.from.apply_case = item.id
      this.isShow = false
    },
    // 申请退款
    applicationFg() {
      this.isShow = true
    },
    addFg() {
      // if (this.isEdit) return
      this.num++
      if (this.num > this.refundInfo.max_edit_num) {
        this.num = this.refundInfo.max_edit_num
        Toast(
          `您最多可${this.goodsInfo.refundId == 3 ? '换' : '退'}${
            this.refundInfo.max_edit_num
          }件`
        )
        return
      }
    },
    blurFg(e) {
      if (this.num > this.refundInfo.max_edit_num) {
        this.num = this.refundInfo.max_edit_num
        Toast(
          `您最多可${this.goodsInfo.refundId == 3 ? '换' : '退'}${
            this.refundInfo.max_edit_num
          }件`
        )
        return
      }
      if (this.num <= 0) {
        this.num = 1
      }
    },
    subtractFg() {
      if (this.isEdit) return
      if (this.num > 1) {
        this.num--
      }
    },
    // 获取售后原因
    async getRefundList() {
      let res = await this.http('ClientOrder.refundApplyCase', {
        order_detail_id: this.$route.query.orderDetailId,
        apply_type: this.$route.query.refundId,
      })
      this.actions = res.content
      // this.from.apply_sn = res.content.apply_sn
    },
    afterRead(file) {
      console.log(file)
      // alert(file.file.name)
      file.status = 'uploading'
      file.message = '上传中...'
      this.Oss.uploadFile('refund/' + file.file.name, file.file).then((res) => {
        console.log(res)
        if (res.msg == 'ok') {
          file.status = ''
          this.videomos = res.url
        }
      })
    },
    sublimeFg() {
      this.images = []
      if (this.from.curRefund == ('请选择' || '')) {
        Toast('请选择申请原因')
        return
      }
      if (this.from.caused == '' || !this.from.caused) {
        Toast(`请填写 ${this.goodsInfo.refundId == 3 ? '换货' : '退货'}说明`)
        return
      }
      if (this.fileList.length == 0) {
        Toast('请先上传图片')
        return
      }
      if (this.videomos == '') {
        Toast('请先上传视频')
        return
      }
      // 先上传图片至oss
      this.isLoading = true
      let that = this
      //循环
      this.fileList.forEach(async (item, index) => {
        if (item) {
          if (item.file) {
            await this.updataImg(item)
          } else {
            this.images.push(item.url)
          }
        }
        if (this.fileList.length == this.images.length) {
          this.saveFg()
        }
      })
      console.log(that.images)
      /*售后类型 apply_type  申请售后数量 apply_num 
       售后原因类型 apply_case 售后申请原因 caused 
       联系人send_back_name 联系人电话 send_back_phone
      售后图片地址多个用,分隔 image 视频地址 video*/
    },
    // 上传
    async updataImg(item) {
      console.log(item)
      let res = await this.Oss.uploadFile('refund/' + item.file.name, item.file)
      console.log(res)
      if (res.msg == 'ok') {
        this.images.push(res.url)
        console.log('ok')
      } else {
        this.isLoading = false
      }
    },
    saveFg() {
      this.from.order_detail_id = this.goodsInfo.orderDetailId
      this.from.apply_type = this.$route.query.refundId
      this.from.apply_num = this.num
      this.from.image = this.images.join(',')
      this.from.video = this.videomos
      this.from.apply_sn = this.$route.query.sn
      console.log(this.$route)
      if (this.$route.query.type == 'edit') {
        //编辑接口
        this.http('ClientOrder.editApply', { ...this.from }).then((res) => {
          if (res.status == 200) {
            this.isLoading = false
            Toast('修改申请成功')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500)
          } else {
            this.isLoading = false
            Toast(res.msg)
          }
          console.log(res)
          return
        })
      } else {
        this.http('ClientOrder.createApply', { ...this.from }).then((res) => {
          if (res.status == 200) {
            this.isLoading = false
            Toast(res.content.tip)
            setTimeout(() => {
              this.$router.push({ path: './aftermarketList' })
            }, 1500)
          } else {
            this.isLoading = false
            Toast(res.msg)
          }
        })
      }
    },
    //获取订单详情
    getOrderDetail() {
      this.http('ClientOrder.childDetail', {
        order_id: this.goodsInfo.orderDetailId,
      }).then((res) => {
        if (res.status == 200) {
          if (this.$route.query.type) {
            this.num = Number(this.from.num)
          } else {
            this.num = this.refundInfo.max_edit_num
          }
          console.log(this.from)
          this.ship_amount_dollar = multiply(
            this.num,
            divide(
              Number(res.content.child_order_list[0].ship_amount_dollar),
              Number(res.content.child_order_list[0].num)
            )
          )
          this.goods_price_dollar = multiply(
            this.num,
            Number(res.content.child_order_list[0].goods_price_dollar)
          )
          this.child_order_list = res.content.child_order_list
          console.log(this.num)
          this.from.refundNum = add(
            multiply(
              Number(res.content.child_order_list[0].goods_price_dollar),
              Number(this.num)
            )
          )
        } else {
          Toast(res.msg)
        }
      })
    },
  },
  watch: {
    num(val) {
      console.log(val)
      this.from.refundNum = multiply(this.goods_price_dollar, val)
      this.ship_amount_dollar = multiply(
        val,
        divide(
          Number(this.child_order_list[0].ship_amount_dollar),
          Number(this.child_order_list[0].num)
        )
      )
      this.goods_price_dollar = multiply(
        val,
        Number(this.child_order_list[0].goods_price_dollar)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.nm_content {
  text-align: center;
  padding: 28px 0;
  font-size: 32px;
  color: #323233;
}
.n_continer {
  height: 100%;
  background: rgba(247, 248, 250, 1);
}
.order_goods {
  position: relative;
  width: 710px;
  height: 188px;
  background: #ffffff;
  border-radius: 14px;
  margin: 0 auto;
  img {
    float: left;
    width: 140px;
    height: 140px;
    border-radius: 10px;
    margin: 24px;
  }
  div {
    width: 476px;
    margin-top: 24px;
    float: left;
    p {
      width: 476px;
      font-size: 28px;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
    }
    b {
      font-size: 24px;
      color: #999;
      padding: 4px 10px;
      background: #f2f2f2;
      border-radius: 8px;
      display: inline-block;
      margin-bottom: 10px;
    }
    span {
      display: block;
      color: #f0240e;
      font-size: 34px;
      i {
        font-size: 28px;
      }
    }
  }
  .apply {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 158px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    font-size: 26px;
    background: #ffffff;
    border-radius: 200px;
    border: 2px solid #dcdee0;
  }
}
.n_content {
  width: 710px;
  margin: 20px auto 0;
  box-sizing: border-box;
  background: #ffffff;
  ul {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 30px;
      .n_num {
        color: rgba(50, 50, 51, 1);
      }
      .n_input {
        width: 64px;
        height: 56px;
        background: #f2f3f5;
        text-align: center;
      }
      .n_jian {
        width: 56px;
        height: 56px;
        background: #f2f3f5;
        border-radius: 8px 0px 0px 8px;
        margin-right: 10px;
        p {
          position: relative;
          top: 50%;
          transform: translate(0, -50%);
          width: 25px;
          height: 2px;
          background: #323233;
          border-radius: 2px;
          margin: auto;
        }
      }
      .n_add {
        width: 56px;
        height: 56px;
        line-height: 56px;
        background: #f2f3f5;
        border-radius: 0px 8px 8px 0px;
        font-size: 45px;
        margin-left: 10px;
        text-align: center;
        color: rgba(50, 50, 51, 1);
      }
    }
  }
}
.align_center {
  align-items: center;
  p {
    margin-right: 20px;
    font-size: 26px;
    color: #999999;
  }
}
.n_padding {
  padding: 30px;
}
.n_oimg {
  font-size: 24px !important;
  color: #969799;
  margin-left: 10px;
}
.n_imgList {
  margin-top: 20px;
}
.n_btn {
  width: 686px;
  height: 96px;
  line-height: 96px;
  text-align: center;
  margin: 85px auto 0;
  background: #ee0a24;
  border-radius: 48px;
  font-size: 28px;
  color: #ffffff;
}
.n_height {
  height: 20px;
}
</style>